import { MAX_VISIBLE_COLUMNS } from '@/constants/tables';

interface HeaderState {
  all: string[];
  visible: string[];
  maxVisible: number;
}

interface TableState {
  headers: HeaderState;
}

export const useUsersTableStore = defineStore('usersTable', {
  state: (): TableState => ({
    headers: {
      all: [],
      visible: [],
      maxVisible: MAX_VISIBLE_COLUMNS,
    },
  }),
  actions: {
    initHeaders(allHeaders: string[], defaultVisible: string[], maxVisible = MAX_VISIBLE_COLUMNS) {
      const persistedVisible = this.headers?.visible ?? [];
      const persistedIsValid
        = persistedVisible.length > 0
          && persistedVisible.every(k => allHeaders.includes(k));

      this.headers = {
        all: allHeaders,
        visible: persistedIsValid
          ? persistedVisible
          : defaultVisible.slice(0, maxVisible),
        maxVisible,
      };
    },

    setVisibleHeaders(visible: string[]) {
      this.headers.visible = visible.slice(0, this.headers.maxVisible);
    },

    isHeaderVisible(header: string): boolean {
      return this.headers.visible.includes(header);
    },

    getVisibleHeaders(): string[] {
      return this.headers.visible;
    },

    getAllHeaders(): string[] {
      return this.headers.all;
    },
  },
  persist: {
    storage: piniaPluginPersistedstate.localStorage(),
  },
});
